// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'Selecteren',
    titleLinkTooltip: 'Ga naar pagina',
    collapseCardTooltip: 'Kaart sluiten',
    expandCardTooltip: 'Kaart openen'
  },
  CardList: {
    loadMore: 'Meer laden',
    notFound: 'Niets gevonden.',
    toolbarSelect: 'Selecteren',
    viewCards: 'Kaarten',
    viewTiles: 'Tegels',
    viewList: 'Lijst',
    toolbarView: 'Weergave'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'Toch sluiten',
    cancel: 'Terug',
    content: 'Weet u zeker dat u dit venster wilt sluiten? Uw wijzigingen zullen verloren gaan.'
  },
  Cuttable: {
    showMore: 'Meer weergeven',
    showLess: 'Minder weergeven'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'Annuleren'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'Annuleren'
  },
  Dropdown: {
    close: 'Sluiten'
  },
  Form: {
    submitButton: 'Opslaan',
    applyButton: 'Toepassen',
    cancelButton: 'Annuleren'
  },
  FormField: {
    clear: 'Leeg maken',
    remove: 'Verwijderen',
    addMore: 'Extra toevoegen',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'Zo maakt u uw wachtwoord sterker:',
    passwordTooShort: 'Maak het wachtwoord langer.',
    lettersLowerCase: 'Gebruik ten minste één kleine letter.',
    lettersUpperCase: 'Gebruik ten minste één hoofdletter.',
    numbers1: 'Gebruik ten minste één cijfer.',
    numbers3: 'Gebruik ten minste drie cijfers.',
    specialChar1: 'Gebruik ten minste één speciaal teken (bijvoorbeeld: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Gebruik ten minste twee speciale tekens (bijvoorbeeld: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Gebruik zowel kleine letters als hoofdletters.',
    comboLettersAndNumbers: 'Gebruik zowel cijfers als letters.',
    comboLettersNumbersSpecial: 'Gebruik cijfers, letters en speciale tekens.',
    yourPasswordIsStrong: 'U kunt het nog verder versterken door het langer te maken.',
    passwordStrength: 'De sterkte van het wachtwoord is %%strength%%.',
    strengthVeryStrong: 'ZEER STERK',
    strengthStrong: 'STERK',
    strengthVeryWeak: 'ZEER ZWAK',
    strengthWeak: 'ZWAK',
    strengthMedium: 'GEMIDDELD',
    hidePassword: 'Wachtwoord verbergen',
    showPassword: 'Wachtwoord tonen',
    generateButton: 'Genereren',
    copyButtonHint: 'Wachtwoord kopiëren',
    copySuccessToast: 'Wachtwoord is gekopieerd',
    generateButtonHint: 'Sterk wachtwoord genereren'
  },
  InPlaceEdit: {
    cancelButtonHint: 'Wijzigingen ongedaan maken',
    editButtonHint: 'Waarde bewerken',
    okButtonHint: 'Wijzigingen opslaan'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'Bestand selecteren...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: '%%totalRows%% items in totaal',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: '%%selectedRows%% van %%totalRows%% items geselecteerd',
    all: 'Alle',
    allItemsOnPageSelected: 'Alle items op de pagina geselecteerd',
    allItemsSelected: 'Alle items geselecteerd',
    selectAllItems: 'Alle items selecteren',
    selectAllItemsOnPage: 'Alle items op de pagina selecteren',
    deselectAll: 'Selectie opheffen',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'Kan niets vinden dat voldoet aan de filter-criteria',
    emptyTitle: 'Hier is helemaal niets',
    filteredDescription: 'Pas uw zoekopdracht aan of verwijder enkele criteria uit het filter en probeer het opnieuw.'
  },
  ListOperation: {
    cancelButton: 'Annuleren'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: 'van %%total%%',
    itemsPerPage: 'Items per pagina',
    all: 'Alles',
    total: 'Pagina %%current%% van %%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'Sluiten',
    cancelButton: 'Annuleren'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'Geen opties',
    placeholder: 'Selecteren...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%% van %%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'Groep sluiten'
  },
  Toast: {
    closeButton: 'Close'
  }
};